// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18s81efg{margin:var(--_129ypg0)}
._p12f1pl1{max-width:29pc}
._p12fko4j{max-width:19pc}
._y3gn1h6o{text-align:center}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/empty-state/dist/esm/styled/container.compiled.css"],"names":[],"mappings":"AAAA,WAAW,sBAAsB;AACjC,WAAW,cAAc;AACzB,WAAW,cAAc;AACzB,WAAW,iBAAiB","sourcesContent":["._18s81efg{margin:var(--_129ypg0)}\n._p12f1pl1{max-width:29pc}\n._p12fko4j{max-width:19pc}\n._y3gn1h6o{text-align:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
